import React from 'react';
import { Target, KeySquare, Palette, Sparkles } from 'lucide-react';

const steps = [
  {
    icon: Target,
    title: 'Choose Your Style',
    description: 'Select from funny, clever, intimidating, or player-based team names.'
  },
  {
    icon: KeySquare,
    title: 'Add Keywords',
    description: 'Customize your team name with keywords that represent your fantasy strategy.'
  },
  {
    icon: Palette,
    title: 'Generate Names',
    description: 'Our AI creates unique fantasy football team names based on your choices.'
  },
  {
    icon: Sparkles,
    title: 'Pick Your Favorite',
    description: 'Save and compare different names until you find the perfect one.'
  }
];

export default function FantasyFootballHowItWorks() {
  return (
    <section className="py-20 bg-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          How Our Fantasy Football Name Generator Works
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-green-200"></div>
              )}
              <div className="relative text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-4">
                  <step.icon className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}